module.exports = __webpack_public_path__ + "11d655af7587f1d963a142fe948feada.svg";